<ng-template #labelTooltipTemplate> {{ getLabelTooltipText() }} </ng-template>

<label
  tiTooltip
  [tooltipTemplate]="labelTooltipTemplate"
  position="bottom"
  filter=".with-tooltip"
  [for]="config.fieldName"
  [ngClass]="{
    clickable: isClickable,
    'with-tooltip': isWithTooltip,
    wide: config?.UIData?.isWide,
    required: isRequired$ | async,
    'with-attention': isAttentionField(),
  }"
  [title]="config.fieldTitle"
  (click)="onLabelClick()">
  <i *ngIf="config?.UIData?.additionalIcon" class="fa {{ config?.UIData?.additionalIcon }} icon"></i>
  <span *ngIf="config.fieldTitle" class="label-text" [tiOverflowTooltip]="{ mode: 'white-background' }" title="{{ config.fieldTitle }}"> {{ config.fieldTitle }} </span>
  <span
    *ngIf="config.description && !config.showInlineDescription"
    tiTooltip
    class="help-info fa fa-question-circle"
    title="{{ config.description }}"
    [tooltipTemplate]="tooltip">
    <ng-template #tooltip>
      <ti-html-content [content]="config.description"></ti-html-content>
    </ng-template>
  </span>
</label>
<i
  *ngIf="isCopyValue() && !(isDisabledGetter && isDisabledGetter())"
  (click)="copyClick()"
  [ngClass]="{ selected: isSelected }"
  class="fa fa-clone icon"
  aria-hidden="true">
</i>
